import { SectionProps } from "../../common/types";
import { Blobs, Blob } from "../../common/Blob";

import { locationToLocationOption } from "@hire/util/locations";
import { Location } from "@hire/schema";

export function OldJobLocations({ fields }: SectionProps) {
  // We'll get rid of this file after the experiment so I don't really care about the type
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const locationPreferences = fields.locationPreferences as Location[];

  return locationPreferences.length > 0 ? (
    <Blobs>
      {locationPreferences.map((l, i) => (
        <Blob bold={i === 0} key={i}>
          {locationToLocationOption(l)?.label ?? ""}
        </Blob>
      ))}
    </Blobs>
  ) : (
    <Blobs>
      <Blob key={0}>[Location]</Blob>
    </Blobs>
  );
}
